/* Not held up to date, deprecated and shall be deleted */

"use strict";

angular.module('app.controllers.debug', [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('debug', {
            url: '/debug',
            controller: 'DebugCtrl',
            templateUrl: 'views/_debug.html',
            parent: 'site',
            breadcrumb: {
                ignore: true
            },
            resolve: {
                dev: function (__Device) {
                    'ngInject';

                    return __Device.$byId("6804077e-b2f0-4acd-9816-2edd2c85d9ef", true).$then(function () {
                        this.$dispatch('build-view-datapoints');
                    }).$asPromise();
                }
            }
        });
    }])
    .controller("DebugCtrl",
        ["$scope", '$rootScope', '__DatapointValue', '__Bundle', '__Datapoint', 'f_Interval', '__Device', '__Favorite', 'sceneSelectDataSourceModal', 'sceneSetAggregateFunctionModal', '__Scene', '__MenuEntry', 'dateTimePickerModal', '$state', 'deviceRoomPickerModal', 'dev',
            function ($scope, $rootScope, __DatapointValue, __Bundle, __Datapoint, f_Interval, __Device, __Favorite, sceneSelectDataSourceModal, sceneSetAggregateFunctionModal, __Scene, __MenuEntry, dateTimePickerModal, $state, deviceRoomPickerModal, dev) {
                // dateTimePickerModal();
                // deviceRoomPickerModal();
                $scope.time = 1800;
                $scope.Device = dev;
                $scope.filter = {
                    DeviceType: {
                        selectable:'multiple'
                    },
                    Device:{
                        selectable:'multiple',
                        checkConfigVersion : 'true'
                    },
                    MenuEntry: {
                        selectable:'multiple'
                    },
                    selectOnlySingleGroup :true
                }
                $scope.$emit('loading-start',{title:'debugging!!'});
        $scope.setARealTime = function(){
           // deviceRoomPickerModal(  $scope.filter);
//            dateTimePickerModal(new moment().format(),{});

            //$scope.setDeviceTypeForDevice = function () {
                var f = {
                    DeviceType: {
                       // list: $scope.deviceTypes,
                        selectable: 'single'
                    },
                    title: 'DEVICE_SelectDeviceTypeForDevice_Modal_Title'
                };

                deviceRoomPickerModal(f).then(function (modal) {
                    modal.close.then(function (data) {
                        if (data) {
                            $scope.Device.DeviceType = data['DeviceType'][0]['$pk'];
                        }
                    });
                });
            //};

        }
                $scope.setATime = function () {
                    sceneSetAggregateFunctionModal({Method:2,BufferedValuesCount:1,ExecutionFrequencySek:20}, 'Edit');
                    return;
                       dateTimePickerModal($scope.time).then(function (modal) {

                        /*
                        modal.close.then(function (data) {
                            if (data) {
                                $scope.time = data;
                            }

                        })*/

                    });
                };

            }])
;
